import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { AuthingButton } from "../../../components/AuthingButton";
import { Button } from "../../../components/Button";
import "./styles.less";

export const IdentifyLog = (props) => {
  const { t } = useTranslation();

  return (
    <div>
      <section className="identify-log">
        <div className="inner basic-column">
          <div className="title">{t("identify.identifyLog.title")}</div>
          <div className="identify-log-card">
            <div className="identify-log-content">
              <div className="title">{t("identify.identifyLog.subtitle")}</div>
              <div className="subtitle">
                {t("identify.identifyLog.subtitle2")}
              </div>
              <div className="descript-list">
                {t("identify.identifyLog.descript1")}
              </div>
              <div className="descript-list">
                {t("identify.identifyLog.descript2")}
              </div>
              <div className="descript-list">
                {t("identify.identifyLog.descript3")}
              </div>
              <div className="descript-list">
                {t("identify.identifyLog.descript4")}
              </div>
            </div>
            <div className="zero-security-img">
              <img
                src="//files.authing.co/authing-website/identify-log.jpg"
                alt="authing"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
